'use strict';

import angular from 'angular';

import uiRouter from 'angular-ui-router';

import routing from './firmwares.routes';
import list from './list';
import edit from './edit';
import add from './add';
import nanoreader from './nanoreader';
import updated from './updated';
import count from './count';
import lang from './lang';
import model from './model';

export default angular.module('updateServerApp.firmwares', [uiRouter, list, edit, add, nanoreader, updated, count, lang, model])
  .config(routing)
  .run(function($rootScope) {
    'ngInject';

    $rootScope.$on('$stateChangeStart', function(event, next, nextParams, current) {
      if(next.name === 'logout' && current && current.name && !current.authenticate) {
        next.referrer = current.name;
      }
    });
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/firmwares/index.js